import { IconButton } from '@atlaskit/button/new';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/glyph/more';
import { element, useElementProps } from '../../core/elements';
import { Layout } from '../container';
import { useMenuData } from './menu';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Menu = element(_ref => {
  let {
    children,
    hide = false,
    toggleDataTable
  } = _ref;
  if (hide) return null;
  const {
    showBorder
  } = useElementProps(Layout);
  return /*#__PURE__*/_jsx("div", {
    style: {
      position: 'absolute',
      top: 0,
      right: 0,
      padding: showBorder ? "var(--ds-space-200)" : 0
    },
    children: /*#__PURE__*/_jsx(DropdownMenu, {
      trigger: _ref2 => {
        let {
          triggerRef,
          ...props
        } = _ref2;
        return /*#__PURE__*/_jsx(IconButton, {
          ...props,
          appearance: "subtle",
          icon: MoreIcon,
          label: "Chart Menu Options",
          ref: triggerRef,
          spacing: "compact"
        });
      },
      shouldRenderToParent: true,
      placement: "top-end",
      spacing: "compact",
      children: /*#__PURE__*/_jsxs(DropdownItemGroup, {
        children: [/*#__PURE__*/_jsx(DropdownItem, {
          onClick: toggleDataTable,
          children: "Show Data Table"
        }, "Show Data Table"), children]
      })
    })
  });
});
export function ChartMenu(props) {
  const {
    toggleDataTable
  } = useMenuData();
  return /*#__PURE__*/_jsx(Menu, {
    ...props,
    toggleDataTable: toggleDataTable
  });
}